import { render, staticRenderFns } from "./MessagesListUser.vue?vue&type=template&id=5cfb0736&scoped=true&"
import script from "./MessagesListUser.vue?vue&type=script&lang=js&"
export * from "./MessagesListUser.vue?vue&type=script&lang=js&"
import style0 from "./MessagesListUser.vue?vue&type=style&index=0&id=5cfb0736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb0736",
  null
  
)

export default component.exports